//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTime, formatDate } from './scheduleTimeUtils.js';
import { sanitizeHtml, bioToHtml } from './sanitizeHtml.js';

export default {
  name: 'SessionPrintView',

  props: {
    session: { type: Object, required: true },
  },

  computed: {
    eventTitle() {
      return (this.$root.config && this.$root.config.eventTitle) || '';
    },
    eventDates() {
      // Plumbed from the eventIntegration payload as raw ISO strings via Task A1's
      // schema extension (eventStartDate / eventEndDate). Compose a single human
      // label using the same date formatter the rest of the schedule uses.
      const cfg = this.$root.config || {};
      const start = formatDate(cfg.eventStartDate || '');
      const end = formatDate(cfg.eventEndDate || '');
      if (start && end && start !== end) return `${start} – ${end}`;
      return start || end || '';
    },
    creditType() {
      const v = this.session && this.session.creditType;
      if (!v || v === 'Not for Credit') return '';
      return v;
    },
    hasTags() {
      const s = this.session;
      return !!(s.sessionFormat || s.preregRequired || this.creditType || (s.topics && s.topics.length));
    },

    sanitizedDescription() {
      return sanitizeHtml(this.session && this.session.description);
    },
  },

  methods: { formatTime, formatDate, bioHtml: bioToHtml },
};
